import React from "react";
import { Modal } from "react-bootstrap";

interface MessageModalProps {
  showModal: boolean;
  handleCloseModal: () => void;
  messageLabel: string;
  children?: React.ReactNode;
  footer?: React.ReactNode;
}
export default function MessageModal(props: MessageModalProps) {
  const { showModal, handleCloseModal, messageLabel, children, footer } = props;
  return (
    <Modal
      show={showModal}
      onHide={handleCloseModal}
      centered={true}
      className="alertbox  modal-lg"
    >
      <Modal.Body>
        <div className="d-flex justify-content-center align-items-center my-4 fw-medium fw-5 fs-5">
          <div className="col-8">
            {/* <label>You are about to delete this Level </label> */}
            <div className=" mx-auto text-center fs-6">{messageLabel}</div>
            {children}
          </div>
        </div>
        <div className="d-flex justify-content-center mb-4">{footer}</div>
      </Modal.Body>
    </Modal>
  );
}
